import React from "react";
import { link } from "react-router-dom";
import Dropdown from "./Dropdown";

const Navbar = ({ toggle }) => {
  return (
    <header className="font-nunito">
      <nav class=" bg-white border-b-2 border-gray-300 text-gray-900 fixed w-full z-50 lg:px-16">
        <div class="container mx-auto flex justify-between ">
          <div class="relative block p-4 lg:p-6">
            <img
              className="w-28 lg:w-40 "
              src="../img/logo-panelo.png"
              alt=""
            />
          </div>
          <ul class="xl:flex justify-center items-center hidden">
            <li class=" hover:text-main-color">
              <a
                href="/"
                class="relative block py-6 px-2 lg:p-6 text-sm lg:text-base "
              >
                Home
              </a>
            </li>
            <li class="hoverable hover:text-main-color">
              <a
                href="/solution"
                class="relative block py-6 px-4 lg:p-6 text-sm lg:text-base"
              >
                Solutions
              </a>
              <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white pt-5 rounded-b-lg">
                <div class="w-full flex flex-wrap justify-between">
                  <ul class=" flex justify-center w-full border-b sm:border-r lg:border-b-0">
                    <li class="flex items-center justify-center p-9 px-6 border-b border-r border-t w-1/2">
                      <div className="ml-3">
                        <a
                          href="/panelo-sign"
                          class=" text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          PANELO SIGN
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center justify-center p-9 px-6 border-b border-t  w-1/2">
                      <div className="ml-3">
                        <a
                          href="/panelo-cms"
                          class=" text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          PANELO CMS
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center justify-center p-9 px-6 border-b border-t border-l  w-1/2">
                      <div className="ml-3">
                        <a
                          href="/panelo-vision"
                          class=" text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          PANELO VISION
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="hoverable hover:text-main-color transition-all">
              <a
                href="#"
                class="relative block py-6 px-4 lg:p-6 text-sm lg:text-base  hover:text-main-color"
              >
                Application
              </a>
              <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white pt-5 rounded-b-md">
                <div class="w-full flex flex-wrap justify-between">
                  <ul class="w-1/3 border-b sm:border-r lg:border-b-0">
                    <li class="flex items-center p-4 px-6 border-b border-t ">
                      <a href="/application/digital-menu-board-tv">
                        <img src="../img/app-1.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/digital-menu-board-tv"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Digital Menu Boards for TV
                          <p class="text-desc-text text-sm font-normal">
                            Manage price/menu update instanly
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="/application/gym-and-fitness">
                        <img src="../img/app-2.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/gym-and-fitness"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Gym & Fitness
                          <p class="text-desc-text text-sm font-normal">
                            Engage customers with training videos or health tips
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="/application/retail">
                        <img src="../img/app-3.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/retail"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Retail
                          <p class="text-desc-text text-sm font-normal">
                            Enhance the shopping experience of your customers
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6">
                      <a href="/application/education">
                        <img src="../img/app-4.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/education"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Education
                          <p class="text-desc-text text-sm font-normal">
                            Educate your students the right way !
                          </p>
                        </a>
                      </div>
                    </li>
                  </ul>
                  <ul class="w-1/3 border-b sm:border-r lg:border-b-0">
                    <li class="flex items-center p-4 px-6 border-b border-t">
                      <a href="/application/religious-venues">
                        <img src="../img/app-5.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/religious-venues"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Religious Venues
                          <p class="text-desc-text text-sm font-normal">
                            Remodel Church facilities for inviting experiences
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="/application/corporate-office">
                        <img src="../img/app-6.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/corporate-office"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Corporate Office
                          <p class="text-desc-text text-sm font-normal">
                            Creates dynamic and healthy culture
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="/application/move-theaters">
                        <img src="../img/app-7.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/move-theaters"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Move Theaters
                          <p class="text-desc-text text-sm font-normal">
                            Add value to your viewer’s experience
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 ">
                      <a href="/application/digital-menu-for-restaurant">
                        <img src="../img/app-8.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/digital-menu-for-restaurant"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Digital Menu for Restaurant
                          <p class="text-desc-text text-sm font-normal">
                            Wonderful guest experience with increase in sales
                          </p>
                        </a>
                      </div>
                    </li>
                  </ul>
                  <ul class="w-1/3 border-b sm:border-r lg:border-b-0">
                    <li class="flex items-center p-4 px-6 border-b border-t">
                      <a href="/application/qr-code-restaurant-menu">
                        <img src="../img/app-9.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/qr-code-restaurant-menu"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          QR Code Restaurant Menu
                          <p class="text-desc-text text-sm font-normal">
                            Make your restaurant more safe to eat
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="#">
                        <img src="../img/app-10.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/art-gallery"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Art Gallery
                          <p class="text-desc-text text-sm font-normal">
                            Promote your art with eye soothing Digital Displays
                          </p>
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center p-4 px-6 border-b">
                      <a href="/application/health-care">
                        <img src="../img/app-11.png" alt="" />
                      </a>
                      <div className="ml-3">
                        <a
                          href="/application/health-care"
                          class="font-bold text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Health Care
                          <p class="text-desc-text text-sm font-normal">
                            Build Connected Facilities
                          </p>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class=" hover:text-main-color">
              <a
                href="/blog"
                class="relative block py-6 px-2 lg:p-6 text-sm lg:text-base"
              >
                Blog
              </a>
            </li>
            <li class="hoverable hover:text-main-color">
              <a
                href="#"
                class="relative block py-6 px-4 lg:p-6 text-sm lg:text-base"
              >
                Partners
              </a>
              <div class="mega-menu mb-16 sm:mb-0 shadow-xl bg-white pt-5 rounded-b-lg">
                <div class="w-full flex flex-wrap justify-between">
                  <ul class=" flex justify-center w-full border-b sm:border-r lg:border-b-0">
                    <li class="flex items-center justify-center p-9 px-6 border-b border-r border-t w-1/2">
                      <div className="ml-3">
                        <a
                          href="/white-label-partner"
                          class=" text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          White Label Partners
                        </a>
                      </div>
                    </li>
                    <li class="flex items-center justify-center p-9 px-6 border-b border-t  w-1/2">
                      <div className="ml-3">
                        <a
                          href="/channel-partner"
                          class=" text-base text-desc-text mb-2 hover:text-main-color"
                        >
                          Channel Partner
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class=" hover:text-main-color">
              <a
                href="/pricing"
                class="relative block py-6 px-2 lg:p-6 text-sm lg:text-base"
              >
                Pricing
              </a>
            </li>
            <li class=" hover:text-main-color">
              <a
                href="/login"
                class="relative block py-6 px-2 lg:p-6 text-sm lg:text-base"
              >
                Login
              </a>
            </li>
            <li class="bg-main-color hover:bg-orange-dark rounded-md text-white">
              <a
                href="/signup"
                class="relative px-4 py-2 block text-sm lg:text-base"
              >
                Sign Up
              </a>
            </li>
          </ul>
          {/* Hamburger Button */}
          <div
            className="cursor-pointer mx-4 flex items-center xl:hidden"
            onClick={toggle}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
